import type { ReactNode } from 'react';

import { CheckmarkIconSmall } from '@liveauctioneers/caterwaul-components/lib/Icons';
import { BodySecondary } from '@liveauctioneers/hammer-ui-core/text';

export type CriteriaListItemProps = {
    children: ReactNode;
    showErrorFeedback: boolean;
    valid: boolean;
};

/**
 * Same behavior as caterwaul PasswordCriteriaList items, but does not pass `valid` to a DOM node
 * (caterwaul forwards it to styled.li, which React 19 rejects when false).
 */
export const CriteriaListItem = ({ children, showErrorFeedback, valid }: CriteriaListItemProps) => (
    <li className="flex list-none items-start justify-start text-left">
        <span className="mr-2xs inline-flex h-md w-md shrink-0 items-center justify-center">
            {valid ? (
                <CheckmarkIconSmall color="green" />
            ) : (
                <span
                    aria-hidden
                    className="hui-text-h5 leading-none text-text-secondary"
                >
                    •
                </span>
            )}
        </span>
        <BodySecondary color={valid ? undefined : showErrorFeedback ? 'critical' : 'secondary'}>
            {children}
        </BodySecondary>
    </li>
);
